import { SortableElement } from "react-sortable-hoc";

import Faq from "./Faq";

export default SortableElement(Faq);
